export const DEFAULT_CLASS =
  'text-chariot-text-primary  placeholder:text-chariot-text-secondary border border-chariot-stroke focus:border-chariot-stroke focus:outline-hidden focus:ring-0';

export const ERROR_CLASS =
  'pr-10 ring-red-300 placeholder:text-red-300 focus:ring-red-500';

export const DISABLED_CLASS =
  'disabled:cursor-not-allowed disabled:bg-chariot-stroke disabled:text-chariot-text-secondary disabled:ring-gray-200';
